(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["apollo-scent-directory"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('apollo-scent-directory')) {
    customElements.define('apollo-scent-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.search = this.querySelector('[data-search]');
        this.family = this.querySelector('[data-family]');
        this.format = this.querySelector('select[data-format]');
        this.stock = this.querySelector('[data-stock]');
        this.items = Array.from(this.querySelectorAll('[data-item]'));
        this.count = this.querySelector('[data-count]');
        this.empty = this.querySelector('[data-empty]');
        this.querySelector('.apollo-directory__filters').hidden = false;
        this.search.addEventListener('input', () => this.filter());
        [this.family, this.format, this.stock].forEach(control => control.addEventListener('change', () => this.filter()));
        this.querySelector('[data-clear]').addEventListener('click', () => {
          this.search.value = ''; this.family.value = ''; this.format.value = ''; this.stock.checked = true; this.filter(); this.search.focus();
        });
        this.filter();
      }
      filter() {
        const terms = this.search.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
        let count = 0;
        this.items.forEach(item => {
          const visible = terms.every(term => item.dataset.searchText.includes(term)) && (!this.family.value || item.dataset.families.split(/\s+/).includes(this.family.value)) && (!this.format.value || item.dataset.format === this.format.value) && (!this.stock.checked || item.dataset.available === 'true');
          item.hidden = !visible;
          if (visible) count++;
        });
        this.count.textContent = count === 1 ? this.count.dataset.single : this.count.dataset.pattern.replace('__COUNT__', count);
        this.empty.hidden = count !== 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
